module.exports = __webpack_public_path__ + "img/PD1505008420812619776.f0a40c6d.png";